
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import SmashableMarkerRocks from "../../editor/entity-markers/SmashableMarkerRocks";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import PlatformMarkerPillar from "../../editor/platform-markers/cave/PlatformMarkerPillar";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import PlatformMarkerPlatLong from "../../editor/platform-markers/cave/PlatformMarkerPlatLong";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import PlatformMarkerPlatMini from "../../editor/platform-markers/cave/PlatformMarkerPlatMini";
import PlatformMarkerRock from "../../editor/platform-markers/cave/PlatformMarkerRock";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerGroundLava from "../../editor/platform-markers/cave/PlatformMarkerGroundLava";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunk1 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6413, 368);
    this.add(editor_bounds_right);

    // platformMarkerStack_1
    const platformMarkerStack_1 = new PlatformMarkerStack1(scene, 3019, 321);
    this.add(platformMarkerStack_1);

    // smashableMarkerRocks_2
    const smashableMarkerRocks_2 = new SmashableMarkerRocks(scene, 1867, -430);
    this.add(smashableMarkerRocks_2);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2039, -314);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2402, 111);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2279, 114);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2542, 114);
    this.add(gemMarker_3);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 1717, -309);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 1348, 153);
    this.add(gemMarker_13);

    // trapMarkerTorch
    const trapMarkerTorch = new TrapMarkerTorch(scene, 1567, 168);
    this.add(trapMarkerTorch);

    // platformMarkerPillar
    const platformMarkerPillar = new PlatformMarkerPillar(scene, 1570, 289);
    this.add(platformMarkerPillar);

    // platformMarkerStack_11
    const platformMarkerStack_11 = new PlatformMarkerStack1(scene, 4370, 321);
    this.add(platformMarkerStack_11);

    // platformMarkerStack_10
    const platformMarkerStack_10 = new PlatformMarkerStack1(scene, 4295, 321);
    this.add(platformMarkerStack_10);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 5691, 285);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 6042, 281);
    this.add(platformMarkerStack_13);

    // platformMarkerStack_15
    const platformMarkerStack_15 = new PlatformMarkerStack1(scene, 294, 326);
    this.add(platformMarkerStack_15);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 4762, 222);
    this.add(gemMarker_14);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 4327, 232);
    this.add(gemMarker_15);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 3673, 241);
    this.add(gemMarker_16);

    // trapMarkerTorch_6
    const trapMarkerTorch_6 = new TrapMarkerTorch(scene, 3745, -472);
    this.add(trapMarkerTorch_6);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 2588, -464);
    this.add(gemMarker_4);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 3483, -460);
    this.add(gemMarker_17);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 1296, -311);
    this.add(gemMarker_18);

    // gemMarker_20
    const gemMarker_20 = new SmallGemMarker(scene, 895, 174);
    this.add(gemMarker_20);

    // gemMarker_21
    const gemMarker_21 = new SmallGemMarker(scene, 1775, 157);
    this.add(gemMarker_21);

    // gemMarker_22
    const gemMarker_22 = new SmallGemMarker(scene, 961, -179);
    this.add(gemMarker_22);

    // gemMarker_23
    const gemMarker_23 = new SmallGemMarker(scene, 632, -9);
    this.add(gemMarker_23);

    // gemMarker_24
    const gemMarker_24 = new SmallGemMarker(scene, 3993, -465);
    this.add(gemMarker_24);

    // platformMarkerStack_6
    const platformMarkerStack_6 = new PlatformMarkerStack1(scene, 4762, 322);
    this.add(platformMarkerStack_6);

    // platformMarkerStack_7
    const platformMarkerStack_7 = new PlatformMarkerStack1(scene, 5318, 319);
    this.add(platformMarkerStack_7);

    // gemMarker_25
    const gemMarker_25 = new SmallGemMarker(scene, 5322, 237);
    this.add(gemMarker_25);

    // gemMarker_26
    const gemMarker_26 = new SmallGemMarker(scene, 5797, 88);
    this.add(gemMarker_26);

    // gemMarker_27
    const gemMarker_27 = new SmallGemMarker(scene, 5288, -186);
    this.add(gemMarker_27);

    // platformMarkerPlatLong
    const platformMarkerPlatLong = new PlatformMarkerPlatLong(scene, 2743, -383);
    this.add(platformMarkerPlatLong);

    // platformMarkerPlat
    const platformMarkerPlat = new PlatformMarkerPlat(scene, 1876, -615);
    this.add(platformMarkerPlat);

    // platformMarkerPlatMid
    const platformMarkerPlatMid = new PlatformMarkerPlatMid(scene, 1867, -222);
    this.add(platformMarkerPlatMid);

    // platformMarkerPlatMini
    const platformMarkerPlatMini = new PlatformMarkerPlatMini(scene, 624, 96);
    this.add(platformMarkerPlatMini);

    // platformMarkerPlatMini_1
    const platformMarkerPlatMini_1 = new PlatformMarkerPlatMini(scene, 966, -81);
    this.add(platformMarkerPlatMini_1);

    // platformMarkerPlatMini_2
    const platformMarkerPlatMini_2 = new PlatformMarkerPlatMini(scene, 1295, -224);
    this.add(platformMarkerPlatMini_2);

    // platformMarkerRock
    const platformMarkerRock = new PlatformMarkerRock(scene, 895, 306);
    this.add(platformMarkerRock);

    // platformMarkerPillar_2
    const platformMarkerPillar_2 = new PlatformMarkerPillar(scene, 1364, 290);
    this.add(platformMarkerPillar_2);

    // platformMarkerPillar_3
    const platformMarkerPillar_3 = new PlatformMarkerPillar(scene, 1794, 284);
    this.add(platformMarkerPillar_3);

    // platformMarkerStack2
    const platformMarkerStack2 = new PlatformMarkerStack2(scene, 2218, 287);
    this.add(platformMarkerStack2);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack2(scene, 2590, 287);
    this.add(platformMarkerStack);

    // platformMarkerPlatMid_1
    const platformMarkerPlatMid_1 = new PlatformMarkerPlatMid(scene, 2406, 201);
    this.add(platformMarkerPlatMid_1);

    // platformMarkerGroundLava
    const platformMarkerGroundLava = new PlatformMarkerGroundLava(scene, 3660, 315);
    this.add(platformMarkerGroundLava);

    // platformMarkerPlatMid_2
    const platformMarkerPlatMid_2 = new PlatformMarkerPlatMid(scene, 5868, 171);
    this.add(platformMarkerPlatMid_2);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 3020, 245);
    this.add(megaGemMarker_2);

    // smashableMarkerRocks
    const smashableMarkerRocks = new SmashableMarkerRocks(scene, 2753, -591);
    this.add(smashableMarkerRocks);

    // platformMarkerPlat_1
    const platformMarkerPlat_1 = new PlatformMarkerPlat(scene, 2762, -774);
    this.add(platformMarkerPlat_1);

    // platformMarkerPlatMini_3
    const platformMarkerPlatMini_3 = new PlatformMarkerPlatMini(scene, 3486, -380);
    this.add(platformMarkerPlatMini_3);

    // platformMarkerPlatMini_4
    const platformMarkerPlatMini_4 = new PlatformMarkerPlatMini(scene, 3739, -382);
    this.add(platformMarkerPlatMini_4);

    // platformMarkerPlatMini_5
    const platformMarkerPlatMini_5 = new PlatformMarkerPlatMini(scene, 3988, -380);
    this.add(platformMarkerPlatMini_5);

    // smashableMarkerRocks_1
    const smashableMarkerRocks_1 = new SmashableMarkerRocks(scene, 4660, -573);
    this.add(smashableMarkerRocks_1);

    // gemMarker_28
    const gemMarker_28 = new SmallGemMarker(scene, 299, 240);
    this.add(gemMarker_28);

    // gemMarker_29
    const gemMarker_29 = new SmallGemMarker(scene, 4507, -440);
    this.add(gemMarker_29);

    // platformMarkerPlat_2
    const platformMarkerPlat_2 = new PlatformMarkerPlat(scene, 4669, -758);
    this.add(platformMarkerPlat_2);

    // platformMarkerPlatMid_3
    const platformMarkerPlatMid_3 = new PlatformMarkerPlatMid(scene, 4660, -365);
    this.add(platformMarkerPlatMid_3);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 2918, -453);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 4816, -438);
    this.add(megaGemMarker_1);

    // platformMarkerPlat_3
    const platformMarkerPlat_3 = new PlatformMarkerPlat(scene, 5297, -100);
    this.add(platformMarkerPlat_3);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 2273, 163);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 3544, 276);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 5733, 122);
    this.add(checkpointMarker_2);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // smashableMarkerRocks_2 (components)
    const smashableMarkerRocks_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_2);
    smashableMarkerRocks_2SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks (components)
    const smashableMarkerRocksSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks);
    smashableMarkerRocksSimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerRocks_1 (components)
    const smashableMarkerRocks_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_1);
    smashableMarkerRocks_1SimpleBreakableBlocker.allowedCharacter = "grizz";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
